
import { Link } from 'react-router-dom';
import { blogPosts } from '../../../mocks/blogPosts';

const latestPosts = blogPosts.slice(0, 3);

export default function BlogPreview() {
  return (
    <section className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-end justify-between mb-8 sm:mb-14">
          <div>
            <p className="text-[#2E7D32] text-xs sm:text-sm mb-2 sm:mb-3 tracking-wider font-medium">
              (FROM THE BLOG)
            </p>
            <h4 className="text-2xl sm:text-4xl font-serif text-gray-900">
              <a href="/blog" className="hover:text-[#2E7D32] transition-colors">
                Latest Articles
              </a>
            </h4>
          </div>

          <Link
            to="/blog"
            className="inline-flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm font-medium text-[#2E7D32] hover:text-[#1B5E20] transition-colors cursor-pointer whitespace-nowrap group"
          >
            <span className="hidden sm:inline">View All Articles</span>
            <span className="sm:hidden">View All</span>
            <span className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-[#E8F5E9] group-hover:bg-[#2E7D32] group-hover:text-white flex items-center justify-center transition-all">
              <i className="ri-arrow-right-line text-xs sm:text-sm"></i>
            </span>
          </Link>
        </div>

        {/* Desktop layout */}
        <div className="hidden sm:grid grid-cols-3 gap-8">
          {latestPosts.map((post, index) => (
            <Link
              key={post.id}
              to={`/blog/${post.id}`}
              className={`group cursor-pointer block overflow-hidden transition-all duration-300 ${
                index === 0
                  ? 'row-span-2 rounded-xl bg-white shadow-sm hover:shadow-xl border border-gray-50'
                  : 'flex gap-5 items-start'
              }`}
            >
              {index === 0 ? (
                <>
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      title={`${post.title} - Daliah Secret`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <span className="absolute top-3 left-3 px-3 py-1 bg-white/90 backdrop-blur-sm text-[#2E7D32] text-[10px] font-semibold rounded-full tracking-wider">
                      {post.category}
                    </span>
                  </div>
                  <div className="p-6">
                    <h3 className="text-lg font-serif text-gray-900 mb-2 leading-snug group-hover:text-[#2E7D32] transition-colors line-clamp-2">
                      {post.title}
                    </h3>
                    <p className="text-gray-500 text-sm mb-4 line-clamp-3 leading-relaxed">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center gap-2">
                      <div className="w-7 h-7 rounded-full bg-[#E8F5E9] flex items-center justify-center">
                        <i className="ri-user-line text-[#2E7D32] text-xs"></i>
                      </div>
                      <div>
                        <p className="text-xs font-medium text-gray-800">{post.author}</p>
                        <p className="text-[10px] text-gray-400">
                          {post.date} &middot; {post.readTime}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="relative w-36 h-28 flex-shrink-0 rounded-lg overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      title={`${post.title} - Daliah Secret`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 py-1">
                    <span className="text-[#2E7D32] text-[10px] font-semibold tracking-wider">
                      {post.category}
                    </span>
                    <h3 className="text-sm font-serif text-gray-900 mt-1 mb-2 leading-snug group-hover:text-[#2E7D32] transition-colors line-clamp-2">
                      {post.title}
                    </h3>
                    <p className="text-[10px] text-gray-400">
                      {post.date} &middot; {post.readTime}
                    </p>
                  </div>
                </>
              )}
            </Link>
          ))}
        </div>

        {/* Mobile layout */}
        <div className="sm:hidden space-y-4">
          {latestPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.id}`}
              className="group flex gap-3.5 items-start cursor-pointer"
            >
              <div className="relative w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  title={`${post.title} - Daliah Secret`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 py-0.5">
                <span className="text-[#2E7D32] text-[10px] font-semibold tracking-wider">
                  {post.category}
                </span>
                <h3 className="text-sm font-serif text-gray-900 mt-1 mb-1.5 leading-snug group-hover:text-[#2E7D32] transition-colors line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-[10px] text-gray-400">
                  {post.date} &middot; {post.readTime}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
